export default __webpack_public_path__ + "static/media/Ana 1.2b7fc12a.svg";